<template>
  <div>
    <router-link
      v-tooltip="{content: $t('ct-edit'), class: 'ba-tooltip-custom'}"
      v-if="!page.is_turbo"
      :to="{name: 'editor', params: { page_id : page.encrypted_id } }"
      class="btn-circle"
      target="_blank"
    >
      <font-awesome-icon
        :icon="['fas', 'pen']"
        class="font-awesome-icon"
      />
    </router-link>

    <router-link
      v-tooltip="{content: $t('ct-edit'), class: 'ba-tooltip-custom'}"
      v-else
      :to="{name: 'CheetahTurboPageEdit', params: { id: website_id, page_id : page.encrypted_id } }"
      class="btn-circle"
      target="_blank"
      v
    >
      <font-awesome-icon
        :icon="['fas', 'pen']"
        class="font-awesome-icon"
      />
    </router-link>

    <button
      v-tooltip="{content: $t('ct-card-eye'), class: 'ba-tooltip-custom'}"
      v-if="!isUnpublish"
      class="btn-circle"
      @click.prevent="$emit('goToWebsitePage',page)"
    >
      <font-awesome-icon
        :icon="['fas', 'eye']"
        class="font-awesome-icon"
      />
    </button>

    <div v-show="!page.is_turbo" class="btn-group">
      <button
        v-tooltip="{content: $t('ct-card-site-settings'), class: 'ba-tooltip-custom'}"
        aria-expanded="false"
        aria-haspopup="true"
        class="btn-circle"
        data-toggle="dropdown"
        type="button"
      >
        <font-awesome-icon :icon="['fas', 'ellipsis-h']" class="font-awesome-icon"/>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <a
          class="dropdown-item"
          href="#"
          @click.prevent="$emit('openSettingsPage')">
          <i class="ct-icon-settings"/>
          {{ $t('ct-settings') }}
        </a>

        <a
          href="#"
          class="dropdown-item"
          data-ba-i="edit-share-img"
          @click.prevent="$emit('uploadImagePage')">
          <i class="ct-icon-share-image"/>
          {{ $t('ct-image-share-edit') }}
        </a>
        <a
          class="dropdown-item"
          href="#"
          @click.prevent="$emit('openVersionsPage')">
          <i class="ct-icon-versions"/>
          {{ $t('ct-versions') }}
        </a>
        <a
          class="dropdown-item"
          href="#"
          @click.prevent="$emit('goToWebsitePage')">
          <i class="ct-icon-external-link"/>
          {{ $t('ct-go-to-website-page') }}
        </a>
        <a
          v-if="!page.is_blog && !page.is_member"
          class="dropdown-item" href="#"
          @click.prevent="$emit('duplicatePageData')">
          <i class="ct-icon-duplicate"/>
          {{ $t('ct-duplicate') }}
        </a>
        <div class="dropdown-divider"/>
        <a
          class="dropdown-item"
          href="#"
          @click.prevent="$emit('confirmDelete','page')">
          <i class="ct-icon-trash text-danger"/>
          {{ $t('ct-delete') }}
        </a>
      </div>
    </div>
    <div v-show="page.is_turbo" class="btn-group">
      <button
        v-tooltip="{content: $t('ct-card-site-settings'), class: 'ba-tooltip-custom'}"
        aria-expanded="false"
        aria-haspopup="true"
        class="btn-circle"
        data-toggle="dropdown"
        type="button"
      >
        <font-awesome-icon :icon="['fas', 'ellipsis-h']" class="font-awesome-icon"/>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <a
          class="dropdown-item"
          href="#"
          @click.prevent="$emit('goToWebsitePage')">
          <i class="svg-icon svgi-open-external svgi-gray"/>
          {{ $t('ct-go-to-website-page') }}
        </a>
        <div class="dropdown-divider"/>
        <a
          class="dropdown-item"
          href="#"
          @click.prevent="$emit('confirmDelete','page', page)">
          <i class="svg-icon svgi-delete"/>
          {{ $t('ct-delete') }}
        </a>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "PagesActions",
  props: ['page', 'isUnpublish', 'website_id']
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/pages/PagesActions.vue